import React from 'react'
import {Icon} from '@chakra-ui/react'

const InfoIcon = (props) => {
    return (
        <Icon viewBox="0 0 14 14" data-testid="info-icon" {...props} sx={{fill: 'none'}}>
            <path
                d="M6.9974 12.8327C10.2191 12.8327 12.8307 10.221 12.8307 6.99935C12.8307 3.77769 10.2191 1.16602 6.9974 1.16602C3.77573 1.16602 1.16406 3.77769 1.16406 6.99935C1.16406 10.221 3.77573 12.8327 6.9974 12.8327Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7 9.33333V7"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7 4.66602H7.00667"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Icon>
    )
}

export default InfoIcon
